import React, { useState } from "react";
import Navbars from "../components/Navbar/Navbars";
import Footer from "../components/Footer/Footer";
import Gallery from "../components/Gallery/Gallery"
// Adjust import path if necessary

// Each service component’s content (details and image)

const Gallerys = () => {
  return (
    <div className="services-page">
      <Navbars />
      <Gallery/>

      <Footer />
    </div>
  );
};

export default Gallerys;
